import { FaXmark } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { useTelegram } from "../../context/TelegramContext";

function AddToHomeScreen({ onClose, onAdded }) {
  const { t } = useTranslation();
  const tg = useTelegram();

  const handleAdd = () => {
    try {
      if (typeof tg?.addToHomeScreen === "function") {
        // addToHomeScreen() з'явився в Telegram WebApp API v8.0+; доступний лише на iOS/Android.
        // Виклик асинхронний: Telegram показує нативний system prompt додати на головний екран.
        tg.addToHomeScreen();
      }
    } catch (e) {
      console.warn("addToHomeScreen failed:", e);
    }
    // Зберігаємо "added" навіть якщо API нема — юзер тепер не побачить попап знову,
    // а фактичне додавання він зробить сам через system prompt Telegram.
    onAdded();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center bg-black/60 backdrop-blur-sm p-0 sm:p-4 animate-fade-in">
      <div className="relative flex flex-col w-full max-w-md p-6 pb-8 shadow-2xl bg-slate-900 rounded-t-3xl sm:rounded-3xl animate-slide-up">
        <button
          onClick={onClose}
          aria-label={t("common.close")}
          className="absolute z-50 flex items-center justify-center w-8 h-8 text-white transition rounded-full shadow-lg top-4 right-4 bg-black/40 backdrop-blur-md hover:bg-black/60"
        >
          <FaXmark className="text-xl" />
        </button>

        <div className="flex flex-col items-center gap-4 pt-2 text-center">
          {/* Лого застосунку */}
          <img
            src="/logo.webp"
            alt="Nirvana AI"
            className="w-20 h-20 rounded-full object-cover shadow-[0_0_30px_rgba(16,185,129,0.4)]"
          />

          {/* Заголовки */}
          <div className="space-y-1">
            <h2 className="text-2xl font-black tracking-wide text-white">
              {t("addToHomeScreen.title")}
            </h2>
            <p className="text-base font-semibold text-cyan-400">
              {t("addToHomeScreen.subtitle")}
            </p>
          </div>

          {/* Опис */}
          <p className="max-w-xs text-sm leading-relaxed text-slate-300">
            {t("addToHomeScreen.description")}
          </p>
        </div>

        {/* Кнопки */}
        <div className="flex flex-col gap-2 mt-6">
          <button
            onClick={handleAdd}
            className="relative w-full py-4 rounded-2xl font-bold text-lg shadow-[0_0_20px_rgba(16,185,129,0.3)] flex items-center justify-center gap-2 overflow-hidden group transition-all bg-gradient-to-r from-emerald-500 via-cyan-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-move text-white active:scale-95"
          >
            <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-10" />
            <span className="relative z-20">{t("addToHomeScreen.button")}</span>
          </button>

          <button
            onClick={onClose}
            className="w-full mt-4 text-base font-semibold transition-all text-white/80 hover:bg-white/10 hover:text-white"
          >
            {t("addToHomeScreen.later")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddToHomeScreen;